import api from "../index";

class BackendAdapter {
  async resolveAsset(assetId) {
    const response = await api({
      method: "GET",
      url: `/storage/assets/${encodeURIComponent(assetId)}/resolve`,
    });
    return response.data;
  }

  async getUrl(filePath, orgId) {
    const response = await api({
      method: "GET",
      url: "/storage/media-url",
      params: { file_path: filePath, org_id: orgId },
    });
    return response.data.url;
  }
}

const mediaUrlAdapter = new BackendAdapter();

export default mediaUrlAdapter;
